import React from "react";
import PropTypes from "prop-types";

import { SFCheckIcon, SFStopIcon } from "../../../icons";
import { SFStack } from "../../../grid";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SFStackWrapper = styled(SFStack)(({ theme }) => ({
  height: "100%",
}));

const SFBooleanRenderer = (props) => {
  // In case a custom valueFormatter is provided, use it to format the value before deciding which icon to display
  let formattedValue =
    props.colDef.valueFormatter &&
    typeof props.colDef.valueFormatter === "function"
      ? props.colDef.valueFormatter(props)
      : props.value;

  // Read icons from context (v33) or colDef (backward compatibility)
  const trueIcon = props.colDef.trueIcon ?? props.colDef.context?.trueIcon ?? <SFCheckIcon color={"green300"} />;
  const falseIcon = props.colDef.falseIcon ?? props.colDef.context?.falseIcon ?? <SFStopIcon />;
  let content = formattedValue ? trueIcon : falseIcon;

  if (!content) {
    return null;
  }

  return (
    <SFStackWrapper alignItems="center" justifyContent={"center"}>
      {content}
    </SFStackWrapper>
  );
};

SFBooleanRenderer.propTypes = {
  trueIcon: PropTypes.element,
  falseIcon: PropTypes.element,
  value: PropTypes.bool,
};

export default SFBooleanRenderer;
